import { atom } from 'jotai';

export type ImageLightboxState = {
  src: string;
  alt: string;
} | null;

/** Active in-note image lightbox (one at a time across editors). */
export const $imageLightbox = atom<ImageLightboxState>(null);
